<template>
  <div>
    <dialog-edit2 :value="value" @input="$emit('input')">
      <template v-slot:title>
        <small v-if="id"> ({{ id }}) </small>
        {{ id ? object.name : "" }}
        <br />
        Покупка по чек-листу
      </template>

      <v-row>
        <br />
        <v-col cols="12" class="pb-0">
          <v-simple-table dense>
            <tbody>
              <tr v-for="(el, i) in m" :key="i">
                <td class="text-left" style="font-weight: 500; height: 38px">
                  {{ el.title }}:
                </td>
                <td class="text-left" style="height: 38px">
                  <component
                    v-if="el.type"
                    :is="'a-view-' + el.type"
                    :model="el"
                    :values="data"
                    :value="data[el.name]"
                  ></component>
                </td>
              </tr>
              <tr v-if="parent">
                <td class="text-left" style="font-weight: 500; height: 38px">
                  Стоимость по смете:
                </td>
                <td class="text-left" style="height: 38px">
                  <component
                    :is="'a-view-string'"
                    :value="parent.price"
                  ></component>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
          <a-form-model
            v-model="data"
            :model="model"
            :errors="errors"
            :config="{ dense: true }"
            @validate="validate($event)"
          />
        </v-col>
      </v-row>
      <template v-slot:actions>
        <v-spacer></v-spacer>
        <a-btn-save @click="submit()" :title="'Закупить'"></a-btn-save>
        <v-btn
          @click="
            $emit('changeStatus');
            $emit('input');
          "
          >Без счета</v-btn
        >
        <v-btn @click="$emit('input')">Закрыть</v-btn>
      </template>
    </dialog-edit2>
  </div>
</template>

<script>
import { getForm, submitForm, removeEl } from "../../components/mixings";
export default {
  mixins: [getForm, submitForm, removeEl],

  props: {
    value: Boolean,
    id: Number,
    object: Object,
  },
  data() {
    return {
      api: "/mechti/finance",
      //model: [{ name: "price", title: "Стоимость покупки", type: "number" }],
      model: this.$store.getters["config/get"].models.goods.formBuy,
      parent: {},
    };
  },
  computed: {
    m() {
      return [
        { name: "name", title: "Заголовок", type: "string" },
        { name: "date_doc", title: "Дата и время", type: "datetime" },
      ];
    },
  },
  watch: {
    value(v) {
      if (v) {
        this.fetchParent(this.object.params);
        const d = new Date();

        let data = {
          name:
            "Покупка по чеклисту #" +
            this.object.params.parent_id +
            ". " +
            this.object.name,
          object_id: this.object.object_id,
          date_doc: d.toISOString(),
          params: {
            parent: this.object.params.parent,
            parent_id: this.object.params.parent_id,
          },
        };
        this.data = Object.assign(this.data, data);
      }
    },
  },
  methods: {
    async fetchParent({ parent, parent_id }) {
      if (parent == "construction-goods") {
        let response = await this.$axios.get(
          "/mechti/" + parent + "/" + parent_id
        );

        this.parent = response.data.data;
      }
    },
    async submit() {
      if (await this.validateAll(this.data)) {
        //console.log('save', this.data);
        await this.post(this.data, this.api);
        return true;
      }
      return false;
    },

    async post(data, api) {
      if (!this.id) return;
      let resp = await this.$axios.get("/mechti/finance", {
        params: {
          filters: {
            object_id: data.object_id,
            params: {
              condition: "LIKE",
              value:
                "%" +
                JSON.stringify({
                  parent_id: this.object.params.parent_id,
                }).replaceAll(/[}{]/g, "") +
                "%",
            },
          },
        },
      });
      if (resp.data.status == "ok") {
        if (Array.isArray(resp.data.data)) {
          if (resp.data.data.length !== 0) {
            let res = resp.data.data.filter((el) => {
              return (
                el?.params?.parent_id == (this.object.params?.parent_id || 0)
              );
            });
            if (res.length !== 0) {
              this.$root.$emit("show-info", {
                type: "error",
                text: "Финансовый документ уже создан. Действие невозможно",
              });
              return;
            }
          }
        } else {
          this.$root.$emit("show-info", {
            type: "error",
            text: "Ошибка проверки. обратитесь к разработчикам.",
          });
          return;
        }
      } else {
        this.$root.$emit("show-info", {
          type: "error",
          text: "Ошибка проверки. обратитесь к разработчикам.",
        });
        return;
      }

      //const data = {};
      //return;
      console.log("buy", api, data);
      this.loading = true;
      let response = await this.$axios.post(api, data, {});
      this.loading = false;
      let status = response.data.status == "ok";
      if (status) {
        this.$root.$emit("show-info", {
          text: "Создан финансовый документ",
        });
      }
      this.afterSave(this.data, status);
    },

    afterSave(data, status) {
      if (status) {
        this.$root.$emit("show-info", {
          text: "покупка совершена",
        });
        this.$emit("input");
        this.$emit("changeStatus");
        // this.$router.push({ name: "objects" });
      }
    },
  },
};
</script>